import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Helper from "../../helper";
import Appconfig from "../../config/config";
import axios from "axios";
import { toast } from "react-toastify";
import "./ScrollGames.css";

const ScrollGames = (props) => {
  const navigate = useNavigate();
  const userInfo = Helper();

  const [
    activeMenu,
    setActiveMenu,
  ] = useState("crash");

  const [activeSport, setActiveSport] = useState(
    props.eventType ?? 4
  );

  function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: "https://daddyexch.live/",
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    var config = {
      method: "post",
      url: `${Appconfig.casinoUrl}wco/login`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(userData),
    };

    axios(config)
      .then(function (response) {
        let status = response.data.status?.code;
        if (status === "SUCCESS") {
          window.open(response.data.launchURL, "_self");
        }

        if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
          toast.error("Game Not Found.", { autoClose: 2000 });
        } else if (status == "AUTHENTICATION_FAILED") {
          toast.error(response.data.status?.message, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const runProtectedAction = (
    menuKey,
    action
  ) => {
    setActiveMenu(menuKey);

    if (!userInfo?._id) {
      navigate("/login");
      return;
    }

    action();
  };

  const changeSport = (eventType) => {
    setActiveSport(eventType);

    // MainScreen ke eventType ko update karega
    if (props.setEventType) {
      props.setEventType(eventType);
    }

    // Old ScrollGames ki tarah home route par eventType bhejega
    navigate("/", {
      state: {
        eventType,
      },
    });
  };

  const casinoMenuGames = {
    crash: {
      providerCode: "SPB",
      gameCode: "avaitor",
    },

    lottery: {
      providerCode: "DC",
      gameCode: "150616",
      type: null,
    },

    sports: {
      providerCode: "BT",
      gameCode: "",
    },

    "our-casino": {
      providerCode: "DC",
      gameCode: "600000",
    },

    "live-casino": {
      providerCode: "DC",
      gameCode: "150000",
    },

    slots: {
      providerCode: "DC",
      gameCode: "902000",
    },

    fantasy: {
      providerCode: "QT",
      gameCode: "KAG-fantasypark",
    },
  };

  const launchCasinoMenuGame = (menuKey) => {
    const game = casinoMenuGames[menuKey];

    setActiveMenu(menuKey);

    if (!userInfo?._id) {
      navigate("/login");
      return;
    }

    if (!game?.providerCode) {
      console.error(
        `Casino configuration missing for ${menuKey}:`,
        game
      );

      toast.error("Casino configuration is missing.", {
        autoClose: 2000,
      });

      return;
    }

    CreateAndLaunchWCOCasino(
      game.providerCode,
      game.gameCode || "",
      game.type || null
    );
  };

  return (
    <nav className="games-navigation">
      {/* Row 1: Casino categories */}
      <div className="casino-menu">
        {/* CRASH */}
        <button
          type="button"
          className={[
            "casino-menu-item",
            "crash-menu",
            activeMenu === "crash" ? "active" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={() => launchCasinoMenuGame("crash")}
        >
          <img
            src={`${process.env.PUBLIC_URL}/Images/crash-plane.svg`}
            alt=""
            className="crash-plane-image"
            aria-hidden="true"
          />

          <span>CRASH</span>
        </button>

        {/* LOTTERY */}
        <button
          type="button"
          className={[
            "casino-menu-item",
            activeMenu === "lottery" ? "active" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={() => launchCasinoMenuGame("lottery")}
        >
          <span>LOTTERY</span>
        </button>

        {/* SPORTS */}
        <button
          type="button"
          className={[
            "casino-menu-item",
            activeMenu === "sports" ? "active" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={() => launchCasinoMenuGame("sports")}
        >
          <span>SPORTS</span>
        </button>

        {/* OUR CASINO */}
        <button
          type="button"
          className={[
            "casino-menu-item",
            "two-line",
            activeMenu === "our-casino" ? "active" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={() =>
            launchCasinoMenuGame("our-casino")
          }
        >
          <span>OUR</span>
          <span>CASINO</span>
        </button>

        {/* LIVE CASINO */}
        <button
          type="button"
          className={[
            "casino-menu-item",
            "two-line",
            activeMenu === "live-casino" ? "active" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={() =>
            launchCasinoMenuGame("live-casino")
          }
        >
          <span>LIVE</span>
          <span>CASINO</span>
        </button>

        {/* SLOTS */}
        <button
          type="button"
          className={[
            "casino-menu-item",
            activeMenu === "slots" ? "active" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={() => launchCasinoMenuGame("slots")}
        >
          <span>SLOTS</span>
        </button>

        {/* FANTASY */}
        <button
          type="button"
          className={[
            "casino-menu-item",
            activeMenu === "fantasy" ? "active" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={() => launchCasinoMenuGame("fantasy")}
        >
          <span>FANTASY</span>
        </button>
      </div>

      {/* Row 2: Sports */}
      <div className="sports-menu">
        <button
          type="button"
          className={`sports-menu-item ${activeSport === 4 ? "active" : ""
            }`}
          onClick={() => changeSport(4)}
        >
          <i className="d-icon icon-4" aria-hidden="true" />
          <span>Cricket</span>
        </button>

        <button
          type="button"
          className={`sports-menu-item ${activeSport === 1 ? "active" : ""
            }`}
          onClick={() => changeSport(1)}
        >
          <i className="d-icon icon-1" aria-hidden="true" />
          <span>Football</span>
        </button>

        <button
          type="button"
          className={`sports-menu-item ${activeSport === 2 ? "active" : ""
            }`}
          onClick={() => changeSport(2)}
        >
          <i className="d-icon icon-2" aria-hidden="true" />
          <span>Tennis</span>
        </button>

        <button
          type="button"
          className={`sports-menu-item ${activeSport === 8 ? "active" : ""
            }`}
          onClick={() => changeSport(8)}
        >
          <i className="d-icon icon-8" aria-hidden="true" />
          <span>Table Tennis</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-10" />
          <span>Horse Racing</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-65" />
          <span>Greyhound Racing</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-15" />
          <span>Basketball</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-68" />
          <span>Esoccer</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-69" />
          <span>Wrestiling</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-18" />
          <span>Volleyball</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-18" />
          <span>Badminton</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-59" />
          <span>Snooker</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-57" />
          <span>Darts</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-6" />
          <span>Boxing</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-3" />
          <span>Mixed Martial Arts</span>

        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-58" />
          <span>American Football</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-11" />
          <span>E Games</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-19" />
          <span>Ice Hockey</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-9" />
          <span>Futsal</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-52" />
          <span>Motor Sports</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-40" />
          <span>Politics</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-65" />
          <span>Greyhound Racing</span>
        </button>

        <button
          type="button"
          className="sports-menu-item"
          onClick={() => navigate("/horse-racing")}
        >
          <i className="d-icon icon-66" />
          <span>Kabaddi</span>
        </button>
      </div>
    </nav>
  );
};


export default ScrollGames;
